import { AbsFn, AvgFn, CeilingFn, ConcatFn, ContainsFn, CountDAFn, CountDFn, CountFn, DataRole, DataType, DateAddFn, DateDiffFn, DateFn, DateNowFn, DatePartFn, DateTime, DateTimeFn, DateTruncFn, ExpFn, ExprNode, ExprValue, FindFn, FirstFn, FloatFn, FloorFn, IfNullFn, IndexFn, IntFn, IsNullFn, KurtFn, LastFn, LeftFn, LnFn, Log10Fn, LookupFn, LowerFn, LtrimFn, MaxFn, MedianFn, MinFn, ModFn, ModeFn, Percentile1Fn, Percentile25Fn, Percentile5Fn, Percentile75Fn, Percentile95Fn, Percentile99Fn, PluckFn, PowerFn, RegexpMatchFn, ReplaceFn, RightFn, RoundFn, RtrimFn, RunningAvgFn, RunningCountFn, RunningSumFn, SkewFn, SqrtFn, StdevFn, StdevPFn, StrFn, SubStrFn, SumFn, TodayFn, TotalFn, TrimFn, TruncFn, Types, UpperFn, VarFn, VarPFn, WindowAvgFn, WindowCountFn, WindowMaxFn, WindowMinFn, WindowSumFn, ZnFn, BinFn, BinSizeFn, } from '@mode-switch/express';
import { Model } from '@mode-switch/model';
export var Catalog;
(function (Catalog) {
    function getExprCall(exprEnv, callName, callArgs, type, role) {
        switch (callName.name) {
            case StrFn.Name:
                return StrFn.make(callName, callArgs, type, role);
            case AbsFn.Name:
                return AbsFn.make(callName, callArgs, type, role);
            case CeilingFn.Name:
                return CeilingFn.make(callName, callArgs, type, role);
            case ExpFn.Name:
                return ExpFn.make(callName, callArgs, type, role);
            case FloorFn.Name:
                return FloorFn.make(callName, callArgs, type, role);
            case Log10Fn.Name:
                return Log10Fn.make(callName, callArgs, type, role);
            case LnFn.Name:
                return LnFn.make(callName, callArgs, type, role);
            case ModFn.Name:
                return ModFn.make(callName, callArgs, type, role);
            case PowerFn.Name:
                return PowerFn.make(callName, callArgs, type, role);
            case RoundFn.Name:
                return RoundFn.make(callName, callArgs, type, role);
            case SqrtFn.Name:
                return SqrtFn.make(callName, callArgs, type, role);
            case TruncFn.Name:
                return TruncFn.make(callName, callArgs, type, role);
            case DateAddFn.Name:
                return DateAddFn.make(callName, callArgs, type, role);
            case DateDiffFn.Name:
                return DateDiffFn.make(callName, callArgs, type, role);
            case DatePartFn.Name:
                return DatePartFn.make(callName, callArgs, type, role);
            case DateTruncFn.Name:
                return DateTruncFn.make(callName, callArgs, type, role);
            case DateNowFn.Name:
                return DateNowFn.make(exprEnv, callName, callArgs, type, role);
            case TodayFn.Name:
                return TodayFn.make(exprEnv, callName, callArgs, type, role);
            case ConcatFn.Name:
                return ConcatFn.make(callName, callArgs, type, role);
            case LowerFn.Name:
                return LowerFn.make(callName, callArgs, type, role);
            case UpperFn.Name:
                return UpperFn.make(callName, callArgs, type, role);
            case TrimFn.Name:
                return TrimFn.make(callName, callArgs, type, role);
            case LtrimFn.Name:
                return LtrimFn.make(callName, callArgs, type, role);
            case RtrimFn.Name:
                return RtrimFn.make(callName, callArgs, type, role);
            case ReplaceFn.Name:
                return ReplaceFn.make(callName, callArgs, type, role);
            case FindFn.Name:
                return FindFn.make(callName, callArgs, type, role);
            case LeftFn.Name:
                return LeftFn.make(callName, callArgs, type, role);
            case RightFn.Name:
                return RightFn.make(callName, callArgs, type, role);
            case PluckFn.Name:
                return PluckFn.make(callName, callArgs, type, role);
            case SubStrFn.Name:
                return SubStrFn.make(callName, callArgs, type, role);
            case AvgFn.Name:
                return AvgFn.make(callName, callArgs, type, role);
            case CountFn.Name:
                return CountFn.make(callName, callArgs, type, role);
            case CountDFn.Name:
                return CountDFn.make(callName, callArgs, type, role);
            case CountDAFn.Name:
                return CountDAFn.make(callName, callArgs, type, role);
            case KurtFn.Name:
                return KurtFn.make(callName, callArgs, type, role);
            case MaxFn.Name:
                return MaxFn.make(callName, callArgs, type, role);
            case MedianFn.Name:
                return MedianFn.make(callName, callArgs, type, role);
            case MinFn.Name:
                return MinFn.make(callName, callArgs, type, role);
            case ModeFn.Name:
                return ModeFn.make(callName, callArgs, type, role);
            case Percentile1Fn.Name:
                return Percentile1Fn.make(callName, callArgs, type, role);
            case Percentile5Fn.Name:
                return Percentile5Fn.make(callName, callArgs, type, role);
            case Percentile25Fn.Name:
                return Percentile25Fn.make(callName, callArgs, type, role);
            case Percentile75Fn.Name:
                return Percentile75Fn.make(callName, callArgs, type, role);
            case Percentile95Fn.Name:
                return Percentile95Fn.make(callName, callArgs, type, role);
            case Percentile99Fn.Name:
                return Percentile99Fn.make(callName, callArgs, type, role);
            case SkewFn.Name:
                return SkewFn.make(callName, callArgs, type, role);
            case SumFn.Name:
                return SumFn.make(callName, callArgs, type, role);
            case StdevFn.Name:
                return StdevFn.make(callName, callArgs, type, role);
            case StdevPFn.Name:
                return StdevPFn.make(callName, callArgs, type, role);
            case VarFn.Name:
                return VarFn.make(callName, callArgs, type, role);
            case VarPFn.Name:
                return VarPFn.make(callName, callArgs, type, role);
            case IntFn.Name:
                return IntFn.make(callName, callArgs, type, role);
            case FloatFn.Name:
                return FloatFn.make(callName, callArgs, type, role);
            case DateFn.Name:
                return DateFn.make(callName, callArgs, type, role);
            case DateTimeFn.Name:
                return DateTimeFn.make(callName, callArgs, type, role);
            case FirstFn.Name:
                return FirstFn.make(callName, callArgs, type, role);
            case IndexFn.Name:
                return IndexFn.make(callName, callArgs, type, role);
            case LastFn.Name:
                return LastFn.make(callName, callArgs, type, role);
            case LookupFn.Name:
                return LookupFn.make(callName, callArgs, type, role);
            case TotalFn.Name:
                return TotalFn.make(callName, callArgs, type, role);
            case RunningAvgFn.Name:
                return RunningAvgFn.make(callName, callArgs, type, role);
            case RunningCountFn.Name:
                return RunningCountFn.make(callName, callArgs, type, role);
            case RunningSumFn.Name:
                return RunningSumFn.make(callName, callArgs, type, role);
            case WindowAvgFn.Name:
                return WindowAvgFn.make(callName, callArgs, type, role);
            case WindowCountFn.Name:
                return WindowCountFn.make(callName, callArgs, type, role);
            case WindowMaxFn.Name:
                return WindowMaxFn.make(callName, callArgs, type, role);
            case WindowMinFn.Name:
                return WindowMinFn.make(callName, callArgs, type, role);
            case WindowSumFn.Name:
                return WindowSumFn.make(callName, callArgs, type, role);
            case RegexpMatchFn.Name:
                return RegexpMatchFn.make(callName, callArgs, type, role);
            case ContainsFn.Name:
                return ContainsFn.make(callName, callArgs, type, role);
            case IfNullFn.Name:
                return IfNullFn.make(callName, callArgs, type, role);
            case IsNullFn.Name:
                return IsNullFn.make(callName, callArgs, type, role);
            case ZnFn.Name:
                return ZnFn.make(callName, callArgs, type, role);
            case BinFn.Name:
                return BinFn.make(callName, callArgs, type, role);
            case BinSizeFn.Name:
                return BinSizeFn.make(callName, callArgs, type, role);
            default:
                throw new Error(`Unknown function ${callName}`);
        }
    }
    Catalog.getExprCall = getExprCall;
    function getCallArgs(model, viewName, callName, callArgs) {
        var _a, _b;
        switch (callName.name) {
            case DatePartFn.Name:
            case DateTruncFn.Name: {
                break;
            }
            default: {
                return callArgs;
            }
        }
        const view = Model.Views.find(model, viewName);
        if (view == null) {
            return callArgs;
        }
        const weekStart = (_a = DateTime.weekStart(view.weekStart)) !== null && _a !== void 0 ? _a : "SUNDAY";
        const yearStart = (_b = DateTime.yearStart(view.yearStart)) !== null && _b !== void 0 ? _b : "JANUARY";
        if (weekStart === "SUNDAY" &&
            yearStart === "JANUARY") {
            return callArgs;
        }
        if (callArgs.length === 2) {
            const arg = ExprNode.StringLiteral.make(weekStart);
            callArgs = [...callArgs, arg];
        }
        if (callArgs.length === 3) {
            const arg = ExprNode.StringLiteral.make(yearStart);
            callArgs = [...callArgs, arg];
        }
        return callArgs;
    }
    Catalog.getCallArgs = getCallArgs;
    function validateExprCall(callNode, callName, callArgs) {
        switch (callName.name) {
            case AbsFn.Name:
                return AbsFn.validate(callNode, callName, callArgs);
            case AvgFn.Name:
                return AvgFn.validate(callNode, callName, callArgs);
            case CeilingFn.Name:
                return CeilingFn.validate(callNode, callName, callArgs);
            case ConcatFn.Name:
                return ConcatFn.validate(callNode, callName, callArgs);
            case ContainsFn.Name:
                return ContainsFn.validate(callNode, callName, callArgs);
            case CountFn.Name:
                return CountFn.validate(callNode, callName, callArgs);
            case CountDFn.Name:
                return CountDFn.validate(callNode, callName, callArgs);
            case CountDAFn.Name:
                return CountDAFn.validate(callNode, callName, callArgs);
            case DateFn.Name:
                return DateFn.validate(callNode, callName, callArgs);
            case DateAddFn.Name:
                return DateAddFn.validate(callNode, callName, callArgs);
            case DateDiffFn.Name:
                return DateDiffFn.validate(callNode, callName, callArgs);
            case DateNowFn.Name:
                return DateNowFn.validate(callNode, callName, callArgs);
            case DatePartFn.Name:
                return DatePartFn.validate(callNode, callName, callArgs);
            case DateTimeFn.Name:
                return DateTimeFn.validate(callNode, callName, callArgs);
            case DateTruncFn.Name:
                return DateTruncFn.validate(callNode, callName, callArgs);
            case ExpFn.Name:
                return ExpFn.validate(callNode, callName, callArgs);
            case FindFn.Name:
                return FindFn.validate(callNode, callName, callArgs);
            case FirstFn.Name:
                return FirstFn.validate(callNode, callName, callArgs);
            case FloorFn.Name:
                return FloorFn.validate(callNode, callName, callArgs);
            case IfNullFn.Name:
                return IfNullFn.validate(callNode, callName, callArgs);
            case IndexFn.Name:
                return IndexFn.validate(callNode, callName, callArgs);
            case IsNullFn.Name:
                return IsNullFn.validate(callNode, callName, callArgs);
            case KurtFn.Name:
                return KurtFn.validate(callNode, callName, callArgs);
            case LastFn.Name:
                return LastFn.validate(callNode, callName, callArgs);
            case LeftFn.Name:
                return LeftFn.validate(callNode, callName, callArgs);
            case LnFn.Name:
                return LnFn.validate(callNode, callName, callArgs);
            case Log10Fn.Name:
                return Log10Fn.validate(callNode, callName, callArgs);
            case LookupFn.Name:
                return LookupFn.validate(callNode, callName, callArgs);
            case LowerFn.Name:
                return LowerFn.validate(callNode, callName, callArgs);
            case LtrimFn.Name:
                return LtrimFn.validate(callNode, callName, callArgs);
            case MaxFn.Name:
                return MaxFn.validate(callNode, callName, callArgs);
            case MedianFn.Name:
                return MedianFn.validate(callNode, callName, callArgs);
            case MinFn.Name:
                return MinFn.validate(callNode, callName, callArgs);
            case ModFn.Name:
                return ModFn.validate(callNode, callName, callArgs);
            case ModeFn.Name:
                return ModeFn.validate(callNode, callName, callArgs);
            case Percentile1Fn.Name:
                return Percentile1Fn.validate(callNode, callName, callArgs);
            case Percentile5Fn.Name:
                return Percentile5Fn.validate(callNode, callName, callArgs);
            case Percentile25Fn.Name:
                return Percentile25Fn.validate(callNode, callName, callArgs);
            case Percentile75Fn.Name:
                return Percentile75Fn.validate(callNode, callName, callArgs);
            case Percentile95Fn.Name:
                return Percentile95Fn.validate(callNode, callName, callArgs);
            case Percentile99Fn.Name:
                return Percentile99Fn.validate(callNode, callName, callArgs);
            case PluckFn.Name:
                return PluckFn.validate(callNode, callName, callArgs);
            case PowerFn.Name:
                return PowerFn.validate(callNode, callName, callArgs);
            case UpperFn.Name:
                return UpperFn.validate(callNode, callName, callArgs);
            case RegexpMatchFn.Name:
                return RegexpMatchFn.validate(callNode, callName, callArgs);
            case ReplaceFn.Name:
                return ReplaceFn.validate(callNode, callName, callArgs);
            case RightFn.Name:
                return RightFn.validate(callNode, callName, callArgs);
            case RoundFn.Name:
                return RoundFn.validate(callNode, callName, callArgs);
            case RtrimFn.Name:
                return RtrimFn.validate(callNode, callName, callArgs);
            case RunningAvgFn.Name:
                return RunningAvgFn.validate(callNode, callName, callArgs);
            case RunningCountFn.Name:
                return RunningCountFn.validate(callNode, callName, callArgs);
            case RunningSumFn.Name:
                return RunningSumFn.validate(callNode, callName, callArgs);
            case SkewFn.Name:
                return SkewFn.validate(callNode, callName, callArgs);
            case SqrtFn.Name:
                return SqrtFn.validate(callNode, callName, callArgs);
            case SumFn.Name:
                return SumFn.validate(callNode, callName, callArgs);
            case StdevFn.Name:
                return StdevFn.validate(callNode, callName, callArgs);
            case StdevPFn.Name:
                return StdevPFn.validate(callNode, callName, callArgs);
            case IntFn.Name:
                return IntFn.validate(callNode, callName, callArgs);
            case FloatFn.Name:
                return FloatFn.validate(callNode, callName, callArgs);
            case StrFn.Name:
                return StrFn.validate(callNode, callName, callArgs);
            case SubStrFn.Name:
                return SubStrFn.validate(callNode, callName, callArgs);
            case TodayFn.Name:
                return TodayFn.validate(callNode, callName, callArgs);
            case TotalFn.Name:
                return TotalFn.validate(callNode, callName, callArgs);
            case TrimFn.Name:
                return TrimFn.validate(callNode, callName, callArgs);
            case TruncFn.Name:
                return TruncFn.validate(callNode, callName, callArgs);
            case VarFn.Name:
                return VarFn.validate(callNode, callName, callArgs);
            case VarPFn.Name:
                return VarPFn.validate(callNode, callName, callArgs);
            case WindowAvgFn.Name:
                return WindowAvgFn.validate(callNode, callName, callArgs);
            case WindowCountFn.Name:
                return WindowCountFn.validate(callNode, callName, callArgs);
            case WindowMaxFn.Name:
                return WindowMaxFn.validate(callNode, callName, callArgs);
            case WindowMinFn.Name:
                return WindowMinFn.validate(callNode, callName, callArgs);
            case WindowSumFn.Name:
                return WindowSumFn.validate(callNode, callName, callArgs);
            case ZnFn.Name:
                return ZnFn.validate(callNode, callName, callArgs);
            case BinFn.Name:
                return BinFn.validate(callNode, callName, callArgs);
            case BinSizeFn.Name:
                return BinSizeFn.validate(callNode, callName, callArgs);
            default:
                throw new Error(`Catalog.validateExprCall: missing validation for ${callName.name}`);
        }
    }
    Catalog.validateExprCall = validateExprCall;
    function getExprCallType(callName, callArgs, argTypes) {
        switch (callName.name) {
            case StrFn.Name:
                return DataType.StringType.make();
        }
        switch (callName.name) {
            case AbsFn.Name:
                return argTypes[0];
            case CeilingFn.Name:
                return DataType.IntegerType.make();
            case ExpFn.Name:
                return DataType.FloatType.make();
            case FloorFn.Name:
                return DataType.IntegerType.make();
            case Log10Fn.Name:
                return DataType.FloatType.make();
            case LnFn.Name:
                return DataType.FloatType.make();
            case ModFn.Name:
                return argTypes[0];
            case PowerFn.Name:
                return argTypes[0];
            case RoundFn.Name:
                return DataType.FloatType.make();
            case SqrtFn.Name:
                return DataType.FloatType.make();
            case TruncFn.Name:
                return DataType.FloatType.make();
        }
        switch (callName.name) {
            case DateDiffFn.Name:
            case DatePartFn.Name:
                return DataType.IntegerType.make();
            case DateAddFn.Name:
                return argTypes[2];
            case DateTruncFn.Name:
                return argTypes[1];
            case DateNowFn.Name:
                return DataType.TimestampType.make();
            case TodayFn.Name:
                return DataType.TimestampType.make();
        }
        switch (callName.name) {
            case ConcatFn.Name:
                return DataType.StringType.make();
            case LowerFn.Name:
                return DataType.StringType.make();
            case UpperFn.Name:
                return DataType.StringType.make();
            case TrimFn.Name:
                return DataType.StringType.make();
            case LtrimFn.Name:
                return DataType.StringType.make();
            case RtrimFn.Name:
                return DataType.StringType.make();
            case ReplaceFn.Name:
                return DataType.StringType.make();
            case FindFn.Name:
                return DataType.IntegerType.make();
            case LeftFn.Name:
                return DataType.StringType.make();
            case RightFn.Name:
                return DataType.StringType.make();
            case PluckFn.Name:
                return DataType.StringType.make();
            case SubStrFn.Name:
                return DataType.StringType.make();
        }
        switch (callName.name) {
            case AvgFn.Name:
                return DataType.FloatType.make();
            case CountFn.Name:
            case CountDFn.Name:
            case CountDAFn.Name:
                return DataType.IntegerType.make();
            case MinFn.Name:
            case MaxFn.Name:
            case SumFn.Name:
                return argTypes[0];
            case KurtFn.Name:
            case SkewFn.Name:
            case StdevFn.Name:
            case StdevPFn.Name:
            case VarFn.Name:
            case VarPFn.Name:
                return DataType.FloatType.make();
            case MedianFn.Name:
            case ModeFn.Name:
            case Percentile1Fn.Name:
            case Percentile5Fn.Name:
            case Percentile25Fn.Name:
            case Percentile75Fn.Name:
            case Percentile95Fn.Name:
            case Percentile99Fn.Name:
                return DataType.FloatType.make();
        }
        switch (callName.name) {
            case IntFn.Name:
                return DataType.IntegerType.make();
            case FloatFn.Name:
                return DataType.FloatType.make();
            case DateFn.Name:
                return DataType.DateTimeType.make();
            case DateTimeFn.Name:
                return DataType.TimestampType.make();
        }
        switch (callName.name) {
            case IndexFn.Name:
            case FirstFn.Name:
            case LastFn.Name:
            case RunningCountFn.Name:
            case WindowCountFn.Name:
                return DataType.IntegerType.make();
            case RunningAvgFn.Name:
            case WindowAvgFn.Name:
                return DataType.FloatType.make();
            case RunningSumFn.Name:
            case WindowMaxFn.Name:
            case WindowMinFn.Name:
            case WindowSumFn.Name:
            case LookupFn.Name:
            case TotalFn.Name:
                return argTypes[0];
        }
        switch (callName.name) {
            case RegexpMatchFn.Name:
            case ContainsFn.Name:
            case IsNullFn.Name:
                return DataType.BooleanType.make();
            case IfNullFn.Name:
                return IfNullFn.getType(argTypes);
            case ZnFn.Name:
                return argTypes[0];
        }
        switch (callName.name) {
            case BinFn.Name:
                return DataType.FloatType.make();
            case BinSizeFn.Name:
                return DataType.FloatType.make();
        }
        throw new Error(`Catalog.getExprCallType: missing case for ${callName.name}`);
    }
    Catalog.getExprCallType = getExprCallType;
    function getExprCallRole(callName, callArgs, argRoles) {
        switch (callName.name) {
            case IfNullFn.Name:
            case StrFn.Name:
                return argRoles[0];
        }
        switch (callName.name) {
            case AbsFn.Name:
            case CeilingFn.Name:
            case ExpFn.Name:
            case FloorFn.Name:
            case Log10Fn.Name:
            case LnFn.Name:
            case ModFn.Name:
            case PowerFn.Name:
            case RoundFn.Name:
            case SqrtFn.Name:
            case TruncFn.Name:
            case ZnFn.Name:
                return argRoles[0];
        }
        switch (callName.name) {
            case FloatFn.Name:
            case IntFn.Name:
            case DateFn.Name:
            case DateTimeFn.Name:
                return argRoles[0];
        }
        switch (callName.name) {
            case DateAddFn.Name:
            case DateDiffFn.Name:
            case DatePartFn.Name:
                return getDatePartRole(callName, callArgs);
            case DateTruncFn.Name:
                return getDateTruncRole(callName, callArgs);
        }
        switch (callName.name) {
            case AvgFn.Name:
            case MaxFn.Name:
            case MedianFn.Name:
            case MinFn.Name:
            case ModeFn.Name:
            case Percentile1Fn.Name:
            case Percentile5Fn.Name:
            case Percentile25Fn.Name:
            case Percentile75Fn.Name:
            case Percentile95Fn.Name:
            case Percentile99Fn.Name:
            case KurtFn.Name:
            case SkewFn.Name:
            case SumFn.Name:
            case StdevFn.Name:
            case StdevPFn.Name:
            case VarFn.Name:
            case VarPFn.Name:
                return argRoles[0];
        }
        switch (callName.name) {
            case LookupFn.Name:
            case TotalFn.Name:
            case RunningAvgFn.Name:
            case RunningCountFn.Name:
            case RunningSumFn.Name:
            case WindowAvgFn.Name:
            case WindowMaxFn.Name:
            case WindowMinFn.Name:
            case WindowSumFn.Name:
            case WindowCountFn.Name:
                return argRoles[0];
        }
        switch (callName.name) {
            case BinFn.Name:
            case BinSizeFn.Name:
                return argRoles[0];
        }
    }
    Catalog.getExprCallRole = getExprCallRole;
    function getDatePartRole(callName, callArgs) {
        const unitNode = callArgs[0];
        switch (unitNode.type) {
            case "STRING_LITERAL": {
                const unit = DateTime.unit(unitNode.value);
                switch (unit) {
                    case "YEAR":
                        return DataRole.DatePart.make("YEAR");
                    case "QUARTER":
                        return DataRole.DatePart.make("QUARTER");
                    case "MONTH":
                        return DataRole.DatePart.make("MONTH");
                    case "DAYOFYEAR":
                        return DataRole.DatePart.make("DAYOFYEAR");
                    case "DAY":
                        return DataRole.DatePart.make("DAY");
                    case "WEEKDAY":
                        return DataRole.DatePart.make("WEEKDAY");
                    case "WEEK":
                        return DataRole.DatePart.make("WEEK");
                    case "HOUR":
                        return DataRole.DatePart.make("HOUR");
                    case "MINUTE":
                        return DataRole.DatePart.make("MINUTE");
                    case "SECOND":
                        return DataRole.DatePart.make("SECOND");
                    default:
                        throw new Error(`${unitNode.value} is not a valid datepart value`);
                }
            }
            default:
                throw new Error(`Cannot determine role of unit at node ${unitNode}`);
        }
    }
    function getDateTruncRole(callName, callArgs) {
        const unitNode = callArgs[0];
        switch (unitNode.type) {
            case "STRING_LITERAL": {
                const unit = DateTime.unit(unitNode.value);
                switch (unit) {
                    case "YEAR":
                        return DataRole.DateTrunc.make("YEAR");
                    case "QUARTER":
                        return DataRole.DateTrunc.make("QUARTER");
                    case "MONTH":
                        return DataRole.DateTrunc.make("MONTH");
                    case "DAYOFYEAR":
                        return DataRole.DateTrunc.make("DAYOFYEAR");
                    case "DAY":
                        return DataRole.DateTrunc.make("DAY");
                    case "WEEKDAY":
                        return DataRole.DateTrunc.make("WEEKDAY");
                    case "WEEK":
                        return DataRole.DateTrunc.make("WEEK");
                    case "HOUR":
                        return DataRole.DateTrunc.make("HOUR");
                    case "MINUTE":
                        return DataRole.DateTrunc.make("MINUTE");
                    case "SECOND":
                        return DataRole.DateTrunc.make("SECOND");
                    default:
                        throw new Error(`Cannot determine role of DATETRUNC unit ${unitNode.value}`);
                }
            }
            default:
                throw new Error(`Cannot determine role of DATETRUNC unit at node ${unitNode}`);
        }
    }
    function isSupportedCallName(callName) {
        switch (callName.name) {
            case StrFn.Name:
            case AbsFn.Name:
            case CeilingFn.Name:
            case ExpFn.Name:
            case FloorFn.Name:
            case Log10Fn.Name:
            case LnFn.Name:
            case ModFn.Name:
            case PowerFn.Name:
            case RoundFn.Name:
            case SqrtFn.Name:
            case TruncFn.Name:
            case ZnFn.Name:
            case FloatFn.Name:
            case IntFn.Name:
            case DateFn.Name:
            case DateTimeFn.Name:
            case DateAddFn.Name:
            case DateDiffFn.Name:
            case DatePartFn.Name:
            case DateTruncFn.Name:
            case DateNowFn.Name:
            case TodayFn.Name:
            case RegexpMatchFn.Name:
            case ContainsFn.Name:
            case IfNullFn.Name:
            case IsNullFn.Name:
            case ConcatFn.Name:
            case LowerFn.Name:
            case UpperFn.Name:
            case TrimFn.Name:
            case RtrimFn.Name:
            case LtrimFn.Name:
            case ReplaceFn.Name:
            case FindFn.Name:
            case LeftFn.Name:
            case RightFn.Name:
            case PluckFn.Name:
            case SubStrFn.Name:
            case AvgFn.Name:
            case CountFn.Name:
            case CountDFn.Name:
            case CountDAFn.Name:
            case KurtFn.Name:
            case MaxFn.Name:
            case MedianFn.Name:
            case MinFn.Name:
            case ModeFn.Name:
            case Percentile1Fn.Name:
            case Percentile5Fn.Name:
            case Percentile25Fn.Name:
            case Percentile75Fn.Name:
            case Percentile95Fn.Name:
            case Percentile99Fn.Name:
            case SkewFn.Name:
            case SumFn.Name:
            case StdevFn.Name:
            case StdevPFn.Name:
            case VarFn.Name:
            case VarPFn.Name:
            case FirstFn.Name:
            case IndexFn.Name:
            case LastFn.Name:
            case LookupFn.Name:
            case TotalFn.Name:
            case RunningAvgFn.Name:
            case RunningCountFn.Name:
            case RunningSumFn.Name:
            case WindowAvgFn.Name:
            case WindowMaxFn.Name:
            case WindowMinFn.Name:
            case WindowSumFn.Name:
            case WindowCountFn.Name:
            case BinFn.Name:
            case BinSizeFn.Name:
                return true;
            default:
                return false;
        }
    }
    Catalog.isSupportedCallName = isSupportedCallName;
    function getLiteralType(node) {
        switch (node.type) {
            case "NullLiteral":
                return DataType.NullType.make();
            case "BooleanLiteral":
                return DataType.BooleanType.make();
            case "HexLiteral":
            case "NumberLiteral":
                if (ExprValue.isInteger(node.value)) {
                    const absValue = ExprValue.abs(node.value);
                    if (ExprValue.lt(absValue, 2 ** 31)) {
                        return DataType.IntegerType.make();
                    }
                }
                return DataType.FloatType.make();
            case "DateLiteral":
                return DataType.DateTimeType.make();
            case "StringLiteral":
                return DataType.StringType.make();
            case "RegExpLiteral":
                return DataType.RegexpType.make();
            default:
                throw new Error(`Unknown data type for value`);
        }
    }
    Catalog.getLiteralType = getLiteralType;
    Catalog.validateRelationalType = (left, right, operator) => {
        const isDateLike = Types.isDateLikeDataType;
        const isNumericLike = Types.isNumericLikeDataType;
        const isNullType = Types.isNullDataType;
        const isSupportedNullRelationalOp = (operator) => {
            switch (operator) {
                case '=':
                case '<>':
                    return true;
                default:
                    return false;
            }
        };
        if (left.name === right.name) {
            return true;
        }
        if (isNumericLike(left) && isNumericLike(right)) {
            return true;
        }
        if (isDateLike(left) && isDateLike(right)) {
            return true;
        }
        const leftIsNull = isNullType(left);
        const rightIsNull = isNullType(right);
        if (leftIsNull || rightIsNull) {
            if (isSupportedNullRelationalOp(operator)) {
                return true;
            }
            const otherType = leftIsNull ? right.name : left.name;
            throw new Error(`Cannot compare <${otherType}> to NULL with "${operator}". ` +
                `Use "=" or "<>" instead`);
        }
        throw new Error(`Cannot determine type of ${left.name} ${operator} ${right.name}`);
    };
})(Catalog || (Catalog = {}));
